<template>
  <div>
    <p class="text-center">选择匹配方式</p>
    <p class="text-center">（将根据您提供的内容进行上刊素材画面匹配）</p>
    <Divider style="margin: 10px 0;"/>

    <p class="m-t-10 m-b-10">
      <Radio v-model="radImg" @on-change="radText = !radImg">图片识别匹配（请上传历史上刊画面素材）</Radio>
    </p>
    <Row>
      <i-col span="24">
        <div
          class="demo-upload-list"
          v-for="(item, index) in defaultFiles"
          :key="'default_' + index"
        >
          <img :src="item.photo + '?x-oss-process=image/resize,w_100'">
          <div class="demo-upload-list-cover">
            <Icon
              type="ios-eye-outline"
              @click="onViewFile(item.photo)"
            ></Icon>
          </div>
        </div>
        <div
          class="demo-upload-list"
          v-for="(item, index) in uploadFiles"
          :key="'file_' + index"
        >
          <template v-if="item.status==='finished'">
            <img :src="item.response.data.link + '?x-oss-process=image/resize,w_100'">
            <div class="demo-upload-list-cover">
              <Icon
                type="ios-eye-outline"
                @click.native="onViewFile(item.response.data.link)"
              ></Icon>
              <Icon
                  type="ios-trash-outline"
                  @click.native="onRemoveFile(item)"
                ></Icon>
            </div>
          </template>
          <template v-else>
            <Progress
              v-if="item.showProgress"
              :percent="item.percentage"
              hide-info
            ></Progress>
          </template>
        </div>
        <Upload
          ref="upload"
          :headers="uploadHeaders"
          :action="uploadUrl"
          :show-upload-list="false"
          :before-upload="onBeforeUpload"
          :on-progress="onProgress"
          :on-success="onUploadSuccess"
          :format="['jpg', 'jpeg', 'png', 'jfif']"
          accept=".jpeg,.jpg,.png,.jfif"
          type="drag"
          style="display: inline-block;width:100%;"
        >
          <div style="padding: 20px 0">
              <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
              <p>点击或拖拽图片进行上传</p>
          </div>
        </Upload>
      </i-col>
    </Row>

    <p class="m-t-20 m-b-10">
      <Radio v-model="radText" @on-change="radImg = !radText">文字识别匹配（请输入历史上刊画面对应描述）</Radio>
    </p>
    <Row class="m-b-20">
      <i-col span="24">
        <Input v-model="searchContent" maxlength="500" show-word-limit type="textarea"
          placeholder="输入关于客户、品牌的描述..." :rows="5" style="width: 100%" />
      </i-col>
    </Row>

    <p class="m-t-20">
      查询相似度 <span class="remark">（* 数值越高，相似度越高）</span>
    </p>
    <Row class="m-b-10">
      <Slider v-model="score" :tip-format="formatSlider" style="width: 200px"></Slider>
      <span class="text-green text-bold m-t-10 m-l-10">{{ score }}</span>
    </Row>

    <p>
      设置查询结果数量 <InputNumber class="m-l-10" size="small" v-model="topN" :max="100" :min="1"></InputNumber>
    </p>

    <Divider style="margin: 10px 0;"/>
    <p class="text-right">
      <Button type="primary" :disabled="allowSubmit" @click="hanldeSubmitNext">开始AI匹配</Button>
    </p>
  </div>
</template>

<script>
import { getStorage } from '@/utils/storage'

export default {
  data () {
    return {
      radImg: true,
      radText: false,
      searchContent: '',
      score: 40,
      topN: 6,

      uploadUrl: `${process.env.VUE_APP_API_URL_V2}/ooh-resource/oss/endpoint/put-file`,
      uploadHeaders: {
        'ooh-auth': getStorage('ooh-token')
      },
      defaultFiles: [],
      uploadFiles: [],
      uploadFileUrl: ''
    }
  },
  methods: {
    onBeforeUpload (file) {
      this.defaultFiles = []
      if (file.type.indexOf('image/') > -1 && file.size > 1024 * 1024 * 20) { // 单个文件不超过20M
        this.$Notice.warning({ desc: '文件名为“' + file.name + '”的文件上传失败，单个文件不超过20M' })
        return false
      }
    },
    onProgress (event, file, fileList) {
      this.uploadFiles = [file]
      event.target.onprogress = (e) => {
        const uploadPercent = parseFloat(((e.loaded / e.total) * 100).toFixed(2))
        file.showProgress = true
        file.percentage = uploadPercent
      }
    },
    onUploadSuccess (response) {
      if (response && response.success) {
        this.uploadFileUrl = response.data.link
      }
    },
    onViewFile (fileUrl) {
      window.open(fileUrl)
    },
    onRemoveFile (item) {
      this.defaultFiles = []
      this.uploadFiles = []
      this.uploadFileUrl = ''
    },
    formatSlider (val) {
      return '相似度: ' + val + '分'
    },
    hanldeSubmitNext () {
      const queryModel = {
        imageUrl: this.radImg ? this.uploadFileUrl : null,
        text: this.radText ? this.searchContent : null,
        score: this.score,
        topN: this.topN,
        pageSize: 4,
        pageNumber: 1
      }

      this.$emit('on-search', queryModel)
    }
  },
  computed: {
    allowSubmit () {
      if (this.radImg) {
        return this.uploadFileUrl.length < 1
      } else {
        return this.searchContent.length < 1
      }
    }
  }
}
</script>
